
import BG from "../assets/about_bg1.JPG";
import TopSection from "../components/topSection";
import "../styles/aboutus.css";

import BookingWizard from "../components/bookingWizard";
function booking() {
  return (
      <>
      <TopSection image={BG} text={"Booking"} backgroundPositionY={"43%"} />
      <section className="light-bg py-5">
        <div className="visit-container container ">
            <div className="col-8 m-auto">
    <BookingWizard />
            </div>
      
        </div>
      </section>
   
    </>
  );
}
  

export default booking;
